<template>
  <LegalNoticeContainer>
    <div class="home-wrapper">
      <h2 class="header">pulseData Application Suite</h2>
      <AppCard
        v-for='app in apps'
        :key='app.id'
        :link="app.url"
        :name="app.title"
        :details="app.description"/>
    </div>
  </LegalNoticeContainer>
</template>

<script>
  import _ from 'lodash'

  import AppCard from '@/components/AppCard'
  import LegalNoticeContainer from 'shared_ui_components/src/components/LegalNoticeContainer'

  export default {
    name: 'Home',
    components: { AppCard, LegalNoticeContainer },
    inject: ['authService'],
    data: function () {
      return {
        user: this.authService.getUser()
      }
    },
    computed: {
      apps () {
        if (!this.user) {
          return []
        } else if (_.size(this.user.enabled_app)) {
          return this.user.apps.filter(a => this.user.enabled_app.includes(a.id))
        } else {
          return this.user.apps || []
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-wrapper {
    padding: 0px 16px;
  }

  .header {
    /* Need to swap margin with padding to prevent margin bleeding to parent and messing up the
      LegalNoticeContainer height.
    */
    margin: 0;
    padding: 26px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue